import Splash from './Splash.view';

export default Splash;
